import { useCallback } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";

function useDeletePlateItem() {
  const [fetchWrapper] = useFetch();
  const showMesssage = useShowMessage();

  const deletePlateItem = useCallback(
    (id) => {
      fetchWrapper({
        endpoint_url: "item_details/deletePlateItem",
        params: {
          id: id,
        },
        onSuccess: (fetch_output) => {
          if ("error" in fetch_output) {
            showMesssage({ message: fetch_output.error });
          }
        },
        onFetchError: () =>
          showMesssage({ apiType: "fetch", message: "Delete Plate Item" }),
        onResponseError: () =>
          showMesssage({ apiType: "response", message: "Delete Plate Item" }),
      });
    },
    [fetchWrapper]
  );

  return { deletePlateItem };
}

export default useDeletePlateItem;
